import React from "react";
import {
  FileTextOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  DeleteColumnOutlined,
} from "@ant-design/icons";
import { formatDate } from "../../../utils/constants";

export const PAGE_SIZE = 10;

export interface StatusConfig {
  color: string;
  label: string;
  icon: React.ReactNode;
}

export const STATUS_PROPOSAL: Record<string, StatusConfig> = {
  draft: { color: "blue", label: "下書き", icon: React.createElement(FileTextOutlined) },
  sent: { color: "green", label: "送付済", icon: React.createElement(ClockCircleOutlined) },
  confirmed: { color: "gold", label: "確定", icon: React.createElement(CheckCircleOutlined) },
  closed: { color: "gray", label: "クローズ", icon: React.createElement(FileTextOutlined) },
};

export const getStatusConfig = (status?: string): StatusConfig => {
  if (!status) {
    return { color: "default", label: "-", icon: React.createElement(FileTextOutlined) };
  }
  return (
    STATUS_PROPOSAL[status.toLowerCase()] || {
      color: "default",
      label: status.toLowerCase(),
      icon: React.createElement(FileTextOutlined),
    }
  );
};

export const formatDisplayDate = (d?: Date | string | number | null): string => {
  if (!d) return "-";
  return formatDate(d) || "-";
};
